/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A box plot shows only quartiles and range; a violin plot shows the entire density, so it reveals skew and multiple peaks (modality) that a box plot cannot.`)
};

const es_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un diagrama de caja solo muestra cuartiles y rango; un gráfico de violín muestra la densidad completa, por lo que revela sesgo y múltiples picos (modalidad) que un diagrama de caja no puede.`)
};

const de_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Boxplot zeigt nur Quartile und Spannweite; ein Violin-Plot zeigt die gesamte Dichte und offenbart so Schiefe und mehrere Gipfel (Modalität), die ein Boxplot nicht zeigen kann.`)
};

const nl_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een boxplot toont alleen kwartielen en bereik; een vioolplot toont de volledige dichtheid, waardoor scheefheid en meerdere pieken (modaliteit) zichtbaar worden die een boxplot niet kan tonen.`)
};

const fr_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un box plot ne montre que les quartiles et l'étendue ; un graphique en violon montre l'ensemble de la densité, révélant ainsi l'asymétrie et les pics multiples (modalité) qu'un box plot ne peut pas montrer.`)
};

const it_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un box plot mostra solo quartili e intervallo; un grafico a violino mostra l'intera densità, quindi rivela asimmetria e picchi multipli (modalità) che un box plot non può mostrare.`)
};

const pt_br2_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um box plot mostra apenas quartis e amplitude; um gráfico de violino mostra a densidade inteira, revelando assimetria e múltiplos picos (modalidade) que um box plot não consegue mostrar.`)
};

const pt_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um box plot mostra apenas quartis e amplitude; um gráfico de violino mostra a densidade completa, revelando assimetrias e vários picos (modalidade) que um box plot não consegue mostrar.`)
};

const ja_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱ひげ図は四分位数と範囲のみを示しますが、バイオリンプロットは密度全体を示すため、箱ひげ図では分からない歪みや複数のピーク(多峰性)を明らかにできます。`)
};

const zh_violin_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱形图只显示四分位数和范围；小提琴图显示完整的密度分布，因此能揭示箱形图无法呈现的偏斜和多峰（多模态）情况。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_faq_a2", locale)
	if (locale === "en") return en_violin_faq_a2(inputs)
	if (locale === "es") return es_violin_faq_a2(inputs)
	if (locale === "de") return de_violin_faq_a2(inputs)
	if (locale === "nl") return nl_violin_faq_a2(inputs)
	if (locale === "fr") return fr_violin_faq_a2(inputs)
	if (locale === "it") return it_violin_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_violin_faq_a2(inputs)
	if (locale === "pt") return pt_violin_faq_a2(inputs)
	if (locale === "ja") return ja_violin_faq_a2(inputs)
	return zh_violin_faq_a2(inputs)
};